module.exports = __webpack_public_path__ + "assets/img/btn-view-8d2931be.png";